import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../button/Button';

interface IProps {
  icon?: ReactNode
  iconLabel?: string
}

const Layout = (icon: IProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <>
      <div className="upload-left">
        <div className="icon-wrapper">
          {icon.icon}
          <div className="icon__content">
            <span className="u-mxs">{icon.iconLabel}</span> <br />
          </div>
        </div>

        <div className="upload-text">
          <span className="main-text">{t('common.drag-file-here')}</span>
          <span className="sub-text u-txt-italic">{t('common.file-accepted')}</span>
        </div>
      </div>

      <div className="browse-wrapper">
        <Button classes="button button-primary--outline button--width-fit u-pys u-pxs" label={t('common.browse')} />
      </div>
    </>
  )
}

export default Layout;
